import React from 'react';
import { MapPin, Gauge, Building, Waves } from 'lucide-react';
import './OperationsPage.css';

const OperationsPage = () => {
  const facilities = [
    {
      name: 'Gdansk Refinery Complex',
      location: 'Gdansk, Poland',
      capacity: '250,000 BPD',
      type: 'Refinery',
      image: 'https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Advanced catalytic cracking',
        'Hydroprocessing units',
        'On-site cogeneration plant'
      ]
    },
    {
      name: 'Baltic Offshore Platform',
      location: 'Baltic Sea',
      capacity: '150,000 BPD',
      type: 'Offshore',
      image: 'https://images.unsplash.com/photo-1578356058390-f58c575337a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxvZmZzaG9yZSUyMG9pbCUyMHJpZ3xlbnwwfHx8fDE3NjUxMzMzNTR8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Deep water drilling capability',
        'Enhanced oil recovery systems',
        'Automated safety protocols'
      ]
    },
    {
      name: 'Silesian Processing Plant',
      location: 'Katowice, Poland',
      capacity: '180,000 BPD',
      type: 'Processing',
      image: 'https://images.unsplash.com/photo-1602056820935-316884c035f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Natural gas processing',
        'Petrochemical production',
        'Waste heat recovery'
      ]
    },
    {
      name: 'Carpathian Drilling Site',
      location: 'Southern Poland',
      capacity: '120,000 BPD',
      type: 'Onshore',
      image: 'https://images.unsplash.com/photo-1690508313456-bf8c851e8319?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxvZmZzaG9yZSUyMG9pbCUyMHJpZ3xlbnwwfHx8fDE3NjUxMzMzNTR8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Directional drilling technology',
        'Environmental monitoring systems',
        'Real-time production data'
      ]
    }
  ];

  const infrastructure = [
    {
      icon: <Building size={32} />,
      title: 'Storage Capacity',
      value: '50M Barrels',
      description: 'Strategic crude and product storage terminals'
    },
    {
      icon: <MapPin size={32} />,
      title: 'Pipeline Network',
      value: '2,500+ Miles',
      description: 'Interstate crude and refined product pipelines'
    },
    {
      icon: <Gauge size={32} />,
      title: 'Processing Capacity',
      value: '2.5M BPD',
      description: 'Combined refining and processing throughput'
    },
    {
      icon: <Waves size={32} />,
      title: 'Marine Terminals',
      value: '8 Facilities',
      description: 'Deep-water port access for crude imports/exports'
    }
  ];

  const capabilities = [
    {
      title: 'Onshore Operations',
      description: 'Conventional and unconventional resource development with advanced drilling technologies and horizontal well capabilities.',
      image: 'https://images.unsplash.com/photo-1673547056773-6e6b6bb4f19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwzfHxvaWwlMjB3b3JrZXJzJTIwc2FmZXR5fGVufDB8fHx8MTc2NTEzMzM2MXww&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Offshore Operations',
      description: 'Deep water exploration and production with state-of-the-art platforms and subsea infrastructure supporting reliable operations.',
      image: 'https://images.unsplash.com/photo-1629540946404-ebe133e99f49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxvZmZzaG9yZSUyMG9pbCUyMHJpZ3xlbnwwfHx8fDE3NjUxMzMzNTR8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Pipeline Infrastructure',
      description: 'Extensive network of crude and product pipelines with advanced monitoring systems ensuring safe and efficient transportation.',
      image: 'https://images.unsplash.com/photo-1714901423336-1884cd3fb50f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxvaWwlMjBwaXBlbGluZXxlbnwwfHx8fDE3NjUxMzMzNjh8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Storage & Logistics',
      description: 'Strategic storage terminals and distribution centers supporting flexible supply chain operations and market responsiveness.',
      image: 'https://images.unsplash.com/photo-1559510981-10719ce4266a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHxvaWwlMjBwaXBlbGluZXxlbnwwfHx8fDE3NjUxMzMzNjh8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <div className="operations-page">
      <section className="operations-hero">
        <div className="operations-hero-overlay"></div>
        <div className="operations-hero-content">
          <h1>Our Operations</h1>
          <p>World-class facilities delivering operational excellence across the energy value chain</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Operational Footprint</h2>
          <p className="section-subtitle">
            Strategic assets positioned across key energy corridors
          </p>

          <div className="facilities-grid">
            {facilities.map((facility, index) => (
              <div key={index} className="facility-card">
                <div className="facility-image">
                  <img src={facility.image} alt={facility.name} />
                  <span className="facility-type">{facility.type}</span>
                </div>
                <div className="facility-content">
                  <h3>{facility.name}</h3>
                  <div className="facility-meta">
                    <span className="facility-location">
                      <MapPin size={16} />
                      {facility.location}
                    </span>
                    <span className="facility-capacity">
                      <Gauge size={16} />
                      {facility.capacity}
                    </span>
                  </div>
                  <ul className="facility-features">
                    {facility.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="infrastructure-section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'white' }}>Infrastructure Capacity</h2>
          <div className="infrastructure-grid">
            {infrastructure.map((item, index) => (
              <div key={index} className="infrastructure-card">
                <div className="infrastructure-icon">{item.icon}</div>
                <h3 className="infrastructure-value">{item.value}</h3>
                <h4 className="infrastructure-title">{item.title}</h4>
                <p className="infrastructure-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Operational Capabilities</h2>
          <p className="section-subtitle">
            Integrated operations delivering reliable energy solutions
          </p>

          <div className="capabilities-grid">
            {capabilities.map((capability, index) => (
              <div key={index} className="capability-card">
                <div className="capability-image">
                  <img src={capability.image} alt={capability.title} />
                </div>
                <div className="capability-content">
                  <h3>{capability.title}</h3>
                  <p>{capability.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="technical-specs-section section">
        <div className="container">
          <h2 className="section-title">Technical Excellence</h2>
          <div className="tech-specs-grid">
            <div className="tech-spec">
              <h4>Advanced Technology</h4>
              <p>Utilizing cutting-edge drilling, processing, and monitoring technologies to maximize efficiency and safety</p>
            </div>
            <div className="tech-spec">
              <h4>Real-Time Monitoring</h4>
              <p>24/7 operational control centers with advanced SCADA systems ensuring optimal performance</p>
            </div>
            <div className="tech-spec">
              <h4>Maintenance Excellence</h4>
              <p>Predictive maintenance programs minimizing downtime and extending asset life</p>
            </div>
            <div className="tech-spec">
              <h4>Environmental Controls</h4>
              <p>State-of-the-art emission controls and environmental monitoring systems</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OperationsPage;